import {
  get,
} from '.';
// eslint-disable-next-line import/prefer-default-export
export const getSearchResults = query => get(`/search/${query}`, {}, 'getSearchResults');
